import cn from 'classnames';
import React from 'react';

export const Pill: React.FC<{
  bgClassName: string;
  children: React.ReactNode;
  icon?: React.ReactNode;
}> = ({ bgClassName, children, icon }) => {
  return (
    <span
      className={cn(
        'flex flex-row items-center gap-1 max-w-fit py-1 px-3 rounded-full',
        bgClassName,
      )}
    >
      {icon}
      {children}
    </span>
  );
};
